import { DefaultPrimaryHeader, HeaderBlock } from '../activityFeedHeaderShared';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { CONSTANTS } from '../../../constants/constants';
import {
  capitalizeFirstLetter,
  formatCisaKevValue,
  formatCvssScore,
  formatEPSSValue,
  formatExploitMaturityValue,
  formatSeverityValue
} from '../../../utils/utils';

const { ACTIVITY_UPDATE_FIELD_LABELS } = CONSTANTS.VULNERABILITIES;

function getVulnerabilityUpdateFieldLabel(field) {
  if (!field) return '';
  return (
    ACTIVITY_UPDATE_FIELD_LABELS[field] ??
    field
      .split('_')
      .map(part => capitalizeFirstLetter(part))
      .join(' ')
  );
}

function getVulnerabilityUpdateValue(field, value) {
  switch (field) {
    case 'epss_score':
      return formatEPSSValue(value);
    case 'cvss_score':
      return formatCvssScore(value);
    case 'severity':
      return formatSeverityValue(value);
    case 'exploit_maturity':
      return formatExploitMaturityValue(value);
    case 'cisa_kev_prevalence':
      return formatCisaKevValue(value);
    default:
      return value ?? '';
  }
}

function VulnerabilityUpdatedHeader({ entity, activity, linkProps }) {
  return (
    <HeaderBlock
      primary={<DefaultPrimaryHeader label={entity.cve} activity={activity} linkProps={linkProps} />}
      secondary={
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
          {entity.vulnerabilityUpdates?.map(update => (
            <Typography key={`${update.field}-${update.previous}-${update.current}`} variant="body2" color="text.secondary">
              {`${getVulnerabilityUpdateFieldLabel(update.field)}: ${getVulnerabilityUpdateValue(
                update.field,
                update.previous
              )} → ${getVulnerabilityUpdateValue(update.field, update.current)}`}
            </Typography>
          ))}
        </Box>
      }
    />
  );
}

export default VulnerabilityUpdatedHeader;
